<template>
  <label
    :class="{ checkBoxTextError: errorBox && !agreementCheckbox}"
    class="ma-0 auth-agreement-checkbox-label"
    @click="eventTrigger($event)"
  >
    {{ $t('auth.registration.agreement')}}
    <a
      class="auth-agreement-checkbox-label"
      :class="{checkBoxTextError: errorBox && !agreementCheckbox }"
      href='https://dolphin-anty.net/legal/terms-of-use.php' target='_blank'
    >
      {{ $t('auth.registration.agreementText1') }}
    </a>
    {{ $t('auth.registration.and') }}
    <a
      class="auth-agreement-checkbox-label"
      :class="{'checkBoxTextError': errorBox && !agreementCheckbox }"
      href='https://dolphin-anty.net/legal/privacy-policy.php' target='_blank'>
      {{ $t('auth.registration.agreementText2') }}
    </a>
  </label>
</template>

<script>
export default {
  name: 'AuthLabel',

  props: {
    agreementCheckbox: {
      type: Boolean,
      required: true
    },
    errorBox: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    eventTrigger(event) {
      this.$emit('toggleAgreement', event)
    }
  }

}
</script>

<style scoped lang='scss'>
.auth-agreement-checkbox-label {
  color: var(--v-text-secondary-base) !important;
  cursor: pointer
}

.checkBoxTextError {
  color: var(--v-input-foreground-error-base) !important;
}
</style>
